import { render, staticRenderFns } from "./ListaAste.vue?vue&type=template&id=2c0c9c12&scoped=true&"
import script from "./ListaAste.vue?vue&type=script&lang=js&"
export * from "./ListaAste.vue?vue&type=script&lang=js&"
import style0 from "./ListaAste.vue?vue&type=style&index=0&id=2c0c9c12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0c9c12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0c9c12')) {
      api.createRecord('2c0c9c12', component.options)
    } else {
      api.reload('2c0c9c12', component.options)
    }
    module.hot.accept("./ListaAste.vue?vue&type=template&id=2c0c9c12&scoped=true&", function () {
      api.rerender('2c0c9c12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ListaAste.vue"
export default component.exports